<template>
    <div id="thread-viewer">
        <div class="toolbar">
            <div class="left"></div>
            <div class="actions">
                <button class="reply" @click="replyToAll(true)">
                    <div class="material-icons" style="font-size: 20px; margin-left: 5px; color: white">reply</div>
                    {{ $t("mail.reply") }}
                </button>
            </div>
        </div>
        <div class="thread" v-if="!!mailDetailsClone && mailDetailsClone.length > 0">
            <div class="thread-header">
                <div class="subject">{{ mailDetailsClone[mailDetailsClone.length - 1].subject }}</div>
                <div class="actions">
                    <div class="muiButtonGroup">
                        <button class="material-icons header-reply" style="font-size: 22px" @click="replyToAll(true)">
                            reply
                        </button>
                        <a-popover id="mail-multi-btn" placement="bottom" trigger="click">
                            <button class="material-icons header-more" style="font-size: 22px">more_vert</button>
                            <div slot="content">
                                <div class="mail-detail" @click="reply(true)">
                                    <span class="material-icons">reply</span>
                                    <span class="mail-detail-item">{{ $t("mail.reply") }}</span>
                                </div>
                                <div class="mail-detail" @click="replyToAll(true)">
                                    <span class="material-icons">reply_all</span>
                                    <span class="mail-detail-item"> {{ $t("mail.replyAll") }} </span>
                                </div>
                                <div class="mail-detail" @click="forwardMail(true)">
                                    <span class="material-icons">forward</span>
                                    <span class="mail-detail-item"> {{ $t("mail.forward") }} </span>
                                </div>
                                <div class="mail-detail" @click="() => (deleteThreadVisible = true)">
                                    <span class="material-icons">delete</span>
                                    <span class="mail-detail-item"> {{ $t("mail.deleteThread") }} </span>
                                </div>
                            </div>
                        </a-popover>
                    </div>
                </div>
            </div>
            <MailComposer
                v-if="replyMessageVisible && (composerView || isVisibleComposer)"
                @closeEditor="replyMessageVisible = false"
                :replyContent="replyContent"
                :isForward="isForward"
                :selectedMailItem="mailDetailsClone[0]"
                :isUserMailDetail="isUserMailDetail"
                :mailDetails="mailDetails"
                @newMailDetail="(e) => (newMailDetail = e)"
                :mailDetailPage="mailDetailPage"
            />
            <div v-for="(mail, i) of mailDetailsClone">
                <div class="tv-content">
                    <div class="tv-header">
                        <div class="avatar"></div>
                        <div class="tv-metas">
                            <div class="left">
                                <div>
                                    <span>{{ $t("mail.From") + ": " }}</span>
                                    <span style="font-weight: 700">{{ getMailAddress(mail.sender) }}</span>
                                </div>
                                <span class="name" v-if="!mail.incoming">
                                    <span>{{ $t("mail.FromName" + "") + ": " }}</span>
                                    <span style="font-weight: 700">{{ getFromMailAddress(mail) }}</span>
                                </span>
                                <span class="to-list">
                                    {{ $t("mail.To") }}:
                                    <span class="ml-2 to-list-single" v-for="to of mail.to_list">
                                        <a-tooltip :title="to">
                                            <span class="name">{{ getMailAddress(to) }}</span>
                                        </a-tooltip>
                                    </span>
                                </span>
                            </div>
                            <div class="right">
                                <span>{{ getTime(mail) }}</span>
                                <a-popover id="mail-multi-btn" placement="bottom" trigger="click">
                                    <md-icon>more_vert</md-icon>
                                    <div slot="content">
                                        <div class="mail-detail" @click="reply(false, mail, i)">
                                            <span class="material-icons">reply</span>
                                            <span class="mail-detail-item"> {{ $t("message.reply") }}</span>
                                        </div>
                                        <div class="mail-detail" @click="replyToAll(mail, i)">
                                            <span class="material-icons">reply_all</span>
                                            <span class="mail-detail-item"> {{ $t("message.replyToAll") }} </span>
                                        </div>
                                        <div class="mail-detail" @click="forwardMail(false, mail, i)">
                                            <span class="material-icons">forward</span>
                                            <span class="mail-detail-item"> {{ $t("message.forward") }} </span>
                                        </div>
                                        <div class="mail-detail" @click="setDeleteThreadMessage(mail)">
                                            <span class="material-icons">delete</span>
                                            <span
                                                class="mail-detail-item"> {{ $t("message.deleteThreadMessage:")
                                                }} </span>
                                        </div>
                                    </div>
                                </a-popover>
                            </div>
                        </div>
                    </div>
                    <MailPreview :html="getMailContent(mail)" class="message-content" :key="mail._id" />
                    <hr class="hr-divider" />
                    <div class="attachments-wrapper" v-if="!!mail.attachments && mail.attachments.length > 0">
                        <span class="title">{{ $t("mail.attachments") }}</span>
                        <div style="display: flex">
                            <div class="attachments" v-for="attachment of mail.attachments">
                                <ImageMessage
                                    v-if="isImage(attachment)"
                                    :message="attachment"
                                    :extended-style="extendedStyle()"
                                    :message-colors="receivedColorsStyle()"
                                />
                                <AssetMessage
                                    v-if="isAsset(attachment)"
                                    :message="attachment"
                                    :extended-style="extendedStyle()"
                                    :message-colors="receivedColorsStyle()"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <MailComposer
                    v-if="!!mail.reply && (composerView || isVisibleComposer)"
                    :selectedMailItem="mail"
                    :replyContent="replyContent"
                    :isForward="isForward"
                    @closeEditor="replyFalse(mail, i)"
                    :isUserMailDetail="isUserMailDetail"
                    :mailDetails="mailDetails"
                    @newMailDetail="(e) => (newMailDetail = e)"
                    :mailDetailPage="mailDetailPage"
                />
            </div>
        </div>
        <a-modal
            id="delete-user-modal"
            title="Maili Sil"
            v-model="deleteThreadMessageVisible"
            v-if="deleteThreadMessageVisible"
            centered
            @ok="deleteThreadMessage"
        >
            <div class="delete-user-modal-message">
                {{ $t("message.deleteMail") }}
            </div>
        </a-modal>
        <a-modal
            id="delete-user-modal"
            title="Tüm Mailleri Sil"
            v-model="deleteThreadVisible"
            v-if="deleteThreadVisible"
            centered
            @ok="deleteThread"
        >
            <div class="delete-user-modal-message">
                {{ $t("message.deleteThread") }}
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import moment from "moment";
import Vue from "vue";
import ImageMessage from "../../../components/popup-chat/messages/ImageMessage.vue";
import AssetMessage from "../../../components/popup-chat/messages/AssetMessage.vue";
import _ from "lodash";
import MailComposer from "./MailComposer.vue";
import NoMessage from "./NoMessage.vue";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import { MAIL_API } from "../../../api/mail";
import MailPreview from "./MailPreview.vue";

const log = log2("ThreadViewer");
export default {
    name: "ThreadViewer",
    components: {
        MailPreview,
        NoMessage,
        MailComposer,
        ImageMessage,
        AssetMessage,
    },
    props: {
        mailDetails: {
            type: Array,
            default: [],
        },
        composerView: {
            type: Boolean,
            default: true,
        },
        isUserMailDetail: {
            type: Boolean,
            default: false,
        },
        mailDetailPage: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            isVisibleComposer: false,
            deleteThreadMessageVisible: false,
            deleteThreadVisible: false,
            deleteMail: {},
            replyMessageVisible: false,
            allContent: [],
            replyContent: "",
            isForward: false,
            mailDetailsClone: [],
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            newMailDetail: {},
            replyIsAll: false,
            replyMail: "",
        };
    },
    computed: {
        ...mapState({
            selectedNewMail: (state) => state.mail.selectedNewMail,
            selectedMailThreadId: (state) => state.mail.selectedMailThreadId,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        isMailDeletePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.delete"]);
        },
    },
    methods: {
        ...mapActions({
            deleteThreadMessageAction: "mail/deleteThreadMessage",
            deleteThreadAction: "mail/deleteThread",
            getMailSignature: "mail/getMailSignature",
            getDepartmentMailAndCount: "mail/getDepartmentMailAndCount",
        }),
        isImage(attachment) {
            return attachment.mime.includes("image") || attachment.type === "image";
        },
        isAsset(attachment) {
            return ["application", "audio", "font", "message", "model", "multipart", "text", "video"].find(
                (type) => attachment.mime.includes(type),
            ) || attachment.type === "asset";
        },
        getMailContent(mail) {
            const textAsHtml = _.get(mail, "raw.textAsHtml");
            const body_html = _.get(mail, "body_html");
            const body_text = _.get(mail, "body_text");

            if (body_html && body_html.trim().toLowerCase() !== "false") {
                return body_html;
            } else {
                return body_text;
            }
        },
        getFromMailAddress(mail) {
            console.log("this.ref_ids", { mail });
            console.log("this.users..", this.users);

            //ref_ids[ref_ids.length - 1] nedeni: mail gönderiminde listenin sonuna gönderen kişinin id değeri eklenmesidir
            const result = this.users.find(
                (user) => user._id === _.get(mail, `ref_user_ids.${mail.ref_user_ids.length - 1}`, ""),
            )?.name;

            console.log("getFromMailAddress result..", result);
            //gelen maillerde ref_user_ids değeri olmaz. Direkt gelen mail adresi yazılır
            if (!!result) {
                return result;
            } else {
                const mailAddress =
                    !!this.allMailAddresses && this.allMailAddresses.length > 0
                        ? this.allMailAddresses.filter((email) => email.mail === mail.sender)[0]
                        : "";
                if (!!mailAddress && mailAddress.type === "visitor") {
                    return mailAddress.visitor.fullname;
                }
            }
        },
        getMailAddress(value) {
            const userMailAddress =
                !!this.allMailAddresses && this.allMailAddresses.length > 0
                    ? this.allMailAddresses.filter(
                        (email) => email.type === "user" && !!email.user && email.user._id === this.user._id,
                    )[0]?.mail
                    : "";
            if (userMailAddress === value) return "Me";
            else {
                const mailAddress =
                    !!this.allMailAddresses && this.allMailAddresses.length > 0
                        ? this.allMailAddresses.filter((email) => email.mail === value)[0]
                        : "";
                if (!!mailAddress && mailAddress.type === "visitor") {
                    return mailAddress.mail;
                } else if (mailAddress && mailAddress.type === "department") {
                    return mailAddress.department.languageContent[0].name;
                } else {
                    return value;
                }
            }
        },
        getTime(mail) {
            return moment(mail.created_at).format("LLL");
        },
        extendedStyle() {
            return {
                width: "auto",
                minWidth: "125px",
                maxWidth: "calc(100% - 60px) !important",
            };
        },
        receivedColorsStyle() {
            return {
                color: this.colors.receivedMessage.text,
                backgroundColor: this.colors.receivedMessage.bg,
            };
        },
        changeReply(index) {
            this.mailDetailsClone.map((mail, item) => {
                mail.reply = item === index;
                Vue.set(this.mailDetails, item, mail);
            });
        },
        readyContent(mail, isAll = false) {
            this.allContent = [];
            this.replyContent = "";
            // gelen parametreleri tutmanın nedeni, from kısmı değiştiriğinde imzayı değiştirken reply verilerinin hatırlanması amacı taşır
            this.replyMail = mail;
            this.replyIsAll = isAll;

            if (!isAll) {
                this.mailDetailsClone.map((item) => {
                    if (mail.created_at >= item.created_at) {
                        this.allContent = [
                            {
                                content: this.getMailContent(item),
                                date: item.created_at,
                                subject: item.subject,
                                to_list: item.to_list,
                                sender: item.sender,
                            },
                            ...this.allContent,
                        ];
                    }
                });
            } else {
                this.mailDetailsClone.map((item) => {
                    this.allContent = [
                        {
                            content: this.getMailContent(item),
                            date: item.created_at,
                            subject: item.subject,
                            to_list: item.to_list,
                            sender: item.sender,
                        },
                        ...this.allContent,
                    ];
                });
            }
            this.allContent.map((item, i) => {
                if (i === this.allContent.length - 1)
                    this.replyContent = `<p><br></p><p><br></p><p> --- ${item.content}</p>` + this.replyContent;
                else
                    this.replyContent =
                        `<p><br></p><p>${item.sender}, ${moment(item.date).format(
                            "LLL",
                        )} tarihinde şunu yazdı:</p><p> > ${item.content}</p>` + this.replyContent;
            });
        },
        reply(isAll = false, mail = {}, index = "") {
            this.isVisibleComposer = true;
            this.isForward = false;
            if (!!isAll) {
                this.replyMessageVisible = true;
                mail = this.mailDetailsClone[0];
            }
            if (!isAll) this.changeReply(index);
            // this.readyContent(mail, isAll);
        },
        replyToAll(isAll = false, mail = {}, index = "") {
            this.isVisibleComposer = true;
            this.isForward = false;
            if (!!isAll) {
                this.replyMessageVisible = true;
                mail = this.mailDetailsClone[0];
            }
            if (!isAll) this.changeReply(index);
            // this.readyContent(mail, isAll);
        },
        forwardMail(isAll = false, mail = {}, index = "") {
            this.isVisibleComposer = true;
            if (!!isAll) {
                this.replyMessageVisible = true;
                mail = this.mailDetailsClone[0];
            }
            if (!isAll) this.changeReply(index);
            // this.readyContent(mail, isAll);
            let toList = "";
            this.isForward = true;
            mail.to_list.map((item) => {
                toList += item + ", ";
            });
            this.replyContent =
                `<p><br></p><p><br></p><p>---------- Forwarded message ---------</p><p>From: ${
                    mail.sender
                }</p><p>Date: ${moment(mail.date).format("LLL")}</p><p>Subject: ${
                    mail.subject
                }</p><p>To: ${toList}</p>` + this.replyContent;
        },
        async deleteThreadMessage() {
            if (!this.isMailDeletePermission) {
                this.$message.error(this.$t("permissionErrors.mailDelete"));
            } else {
                await this.deleteThreadMessageAction(this.deleteMail);
                this.mailDetailsClone = this.mailDetailsClone.filter((item) => item._id !== this.deleteMail._id);
                this.deleteThreadMessageVisible = false;
                this.deleteMail = {};
            }
        },
        async setDeleteThreadMessage(mail) {
            if (!this.isMailDeletePermission) {
                this.$message.error(this.$t("permissionErrors.mailDelete"));
            } else {
                this.deleteThreadMessageVisible = true;
                this.deleteMail = mail;
            }
        },
        async deleteThread() {
            if (!this.isMailDeletePermission) {
                this.$message.error(this.$t("permissionErrors.mailDelete"));
            } else {
                const threadId = this.mailDetailsClone[0].thread_id;
                this.mailDetailsClone = [];
                await this.deleteThreadAction(threadId);
                this.deleteThreadVisible = false;
            }
        },
        replyFalse(mail, index) {
            mail.reply = !mail.reply;
            Vue.set(this.mailDetails, index, mail);
        },
    },
    async mounted() {
        this.mailDetailsClone = _.cloneDeep(this.mailDetails);
        this.mailDetailsClone = this.mailDetailsClone.map((item) => {
            if (!!item.attachments && item.attachments.length > 0) {
                item.attachments = item.attachments.map((attachment) => {
                    attachment.type = ["jpg", "jpeg", "png"].includes(attachment.ext) ? "image" : "asset";
                    attachment.isMail = true;
                    return attachment;
                });
            }
            return item;
        });
    },
    watch: {
        newMailDetail(val) {
            this.mailDetailsClone = [val, ...this.mailDetailsClone];
        },
        selectedMailThreadId(val) {
            this.replyMessageVisible = false;
        },
        mailDetails(val) {
            console.log("threadViewer mailDetails..", val);
            this.isVisibleComposer = false;
            val = val.map((item) => {
                if (!!item.attachments && item.attachments.length > 0) {
                    item.attachments = item.attachments.map((attachment) => {
                        attachment.type = ["jpg", "jpeg", "png"].includes(attachment.ext) ? "image" : "asset";
                        attachment.isMail = true;
                        return attachment;
                    });
                }
                return item;
            });
            this.mailDetailsClone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.mail-detail {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .mail-detail-item {
        margin-left: 5px;
    }

    &:hover {
        background-color: #edf1f4;
    }
}

#thread-viewer {
    padding: 10px 20px 20px;
    width: 57%;
    overflow: auto;

    .toolbar {
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .left {
            width: 70%;
        }

        .actions {
            display: flex;
            grid-gap: 5px;
            gap: 5px;

            .reply {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 5px;
                color: #fff;
                background-color: #009688;
                border: none;
                padding: 4px 10px;
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
                0px 1px 5px 0px rgba(0, 0, 0, 0.12);
            }
        }
    }

    .thread {
        width: 90%;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
        border: 1px solid var(--color-border-default);

        .thread-header {
            display: flex;
            flex: 1 1 auto;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;
            padding: 20px;
            border-bottom: 1px solid var(--color-border-default);

            .muiButtonGroup {
                display: inline-flex;
                border-radius: 4px;

                .header-reply {
                    border: 0.5px solid #5a5f72;
                    border-radius: 4px 0 0 4px;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.04);
                    }
                }

                .header-more {
                    border: 0.5px solid #5a5f72;
                    border-radius: 0 4px 4px 0;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.04);
                    }
                }
            }

            .subject {
                font-size: 18px;
                font-weight: 700;
                color: var(--color-text-strong-default);
            }
        }

        .tv-content {
            display: flex;
            flex-flow: column;
            padding: 20px 20px 16px;
            width: 100%;
            border-bottom: 1px solid var(--color-border-default);
        }

        .message-content {
            margin-top: 20px;
            max-width: 100%;
            overflow-wrap: anywhere;
        }

        .tv-header {
            display: flex;
            align-items: center;
            grid-gap: 10px;
            gap: 10px;
            width: 100%;
            cursor: pointer;

            .avatar {
                display: inline-block;
                vertical-align: middle;
                width: 30px;
                height: 30px;
                border-radius: 25px;
                font-family: Helvetica, Arial, sans-serif;
                background-color: #8d5cc6;
            }

            .tv-metas {
                display: flex;
                justify-content: space-between;
                width: 100%;

                .to-list {
                    flex-wrap: wrap;
                    display: inline-flex;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    .to-list-single {
                        margin-left: 0.5rem !important;
                        background-color: #ededed;
                        padding: 3px;
                        border-radius: 10px;
                        margin-bottom: 5px;
                        padding: 3px 5px;
                    }
                }

                .left {
                    display: flex;
                    flex-direction: column;
                    grid-gap: 5px;
                    gap: 5px;
                    width: 70%;

                    .name {
                        width: min-content;
                        flex-wrap: wrap;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .right {
                }
            }
        }

        .tv-body {
            margin-top: 20px;
            padding: 10px;
            word-break: break-word;
            line-height: 24px;
            color: var(--color-text-strong-default);
            font-size: 14px;
            font-weight: 400;
        }

        .hr-divider {
            border: none;
            height: 1px;
            margin: 0;
            flex-shrink: 0;
            background-color: rgba(0, 0, 0, 0.12);
        }

        .attachments-wrapper {
            display: flex;
            flex-direction: column;
            grid-gap: 10px;
            gap: 10px;

            .title {
                font-size: 14px;
                font-weight: 600;
                color: var(--color-text-strong-default);
                text-transform: uppercase;
                margin-top: 5px;
            }

            .attachments {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                grid-gap: 10px;
                gap: 10px;
                padding-right: 20px;
            }
        }
    }
}
</style>
